import { request } from "@esri/arcgis-rest-request";

export const DeleteWwtp = async (payLoad, Config) =>  {

  try {  
        const resp = await request(`${Config.server.portalUrl}/sharing/servers/${Config.server.wwtpFeaturePortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/2/deleteFeatures`,{
            httpMethod: 'POST',
            params: {
                token: Config.server.apiKey,
                objectIds: payLoad,
                f: "json"
           }});
        //const data = await resp.json();
        console.log(resp);
        if (resp.deleteResults[0].success)
            return true;
        else
            return false;
    } catch (error) {
        console.log(error);
        return false;
    } 

}


